// 搜索接口
import { get, post } from '~/assets/js/api/methods'

import apiList from '~/api.config.js'
const { testwikidatacenter, homeClient } = apiList

export default (axios) => ({
  /*
    服务端请求
  */
  // 默认无参数所有交易商
  index: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/search/index/init-v1`, params),
  // 监管机构 /wikifxweb-v1/regulator/index/init-v1
  regulator: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/regulator/index/init-v1`, params),
  // 有参数（keyword）交易商
  detail: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/search/detail/init-v1`, params),
  /*
    客户端请求
  */
  // 切换标签
  switch: (params = {}, headers = {}) => get(axios, `${homeClient}/wikifxweb-v1/search/detail/switch-v1`, params, false, headers),
  // m端搜索提示
  tips: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/trader/dropdown-v1`, params),
  clientDetail: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/search/detail/init-v1`, params),
  // 搜索统计
  collect: (params = {}) => post(axios, `${homeClient}/wikifxweb-v1/search/statistics/collect-v1`, params)
})
